import { useState } from "react";
import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { ExportToExcelButton } from "../../components/userLog/ExportToExcelBtn.component";
import { UserLogTable } from "../../components/userLog/ListTable.component";
import { SearchUserLogButton } from "../../components/userLog/SearchButton.component";
export const UserLogList = () => {
  const [searchKey, setSearchKey] = useState<string>("");
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <div className="d-flex flex-row align-items-center justify-content-between mb-3 px-1">
            <div>
              <p className="content-header">
                User Log <BreadCrumbSign /> List
              </p>
            </div>
            {/* <div className="d-flex justify-content-between align-content-center">
              <ExportToExcelButton />
              <SearchUserLogButton
                searchKey={searchKey}
                setSearchKey={setSearchKey}
              />
            </div> */}
          </div>
          {/* <UserLogTable searchKey={searchKey} /> */}
        </div>
         <div className="black-list-email-card d-flex justify-content-center py-3 mt-3">
            <h5>Feature Coming Soon......!</h5>
          </div>
      </div>
    </div>
  );
};
